"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends5 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _utils = require("../utils");
var _consts = require("../utils/consts");
var _excluded = ["next_anchor"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The activity service class, which provides the ability to manage activities.
 */
var Activity = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Activity(sdk) {
    (0, _classCallCheck2["default"])(this, Activity);
    return _callSuper(this, Activity, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Activity, _Base);
  return (0, _createClass2["default"])(Activity, [{
    key: "getFileAvailableGroups",
    value: (
    /**
     * Load file activities available groups
     * https://platform.stoplight.autodesk.com/docs/docs-v1/ce9fcf51e036b-available-activity-groups
     *
     * @param projectId - the project id
     * @param payload - The payload with timezone and entity_urn
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with list of available groups, shape of ['activity.today', 'activity.last_month']
     */
    function () {
      var _getFileAvailableGroups = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, payload, config) {
        var _this = this;
        var conf, query, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              conf = (0, _extends5["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this.getFileGroupsToken;
                },
                setter: function setter(token) {
                  return _this.getFileGroupsToken = token;
                },
                clearer: function clearer() {
                  return _this.getFileGroupsToken = undefined;
                }
              }), config);
              query = _qs["default"].stringify((0, _extends5["default"])({
                timezone: _utils.DateUtil.getTimezone()
              }, payload), {
                addQueryPrefix: true
              });
              _context.next = 4;
              return this.HttpService.dmV1.get("/activity/projects/".concat(projectId, "/available_groups").concat(query), conf);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", Array.isArray(res.data) ? res.data : []);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFileAvailableGroups(_x, _x2, _x3) {
        return _getFileAvailableGroups.apply(this, arguments);
      }
      return getFileAvailableGroups;
    }()
    /**
     * Load single file activities
     * https://platform.stoplight.autodesk.com/docs/docs-v1/e54d17e592ac3-filter-activities-by-project-or-file-level
     *
     * @param projectId -  the project id
     * @param payload - the request body for file activities, shape of
     *                          entity_urn: string,
     *                          timezone: 'Asia/Shanghai',
     *                          prior_to: string,
     *                          next_anchor: string,
     *                          users: array,
     *                          verbs: array,
     *                          from: 'YYYY-MM-DD',
     *                          to: 'YYYY-MM-DD'
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise shape of `activities` and `next_anchor`
     */
    )
  }, {
    key: "getFileActivities",
    value: (function () {
      var _getFileActivities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, payload, config) {
        var params, res, _ref, next_anchor, rest;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = (0, _extends5["default"])({
                timezone: _utils.DateUtil.getTimezone()
              }, payload);
              _context2.next = 3;
              return this.HttpService.dmV1.post("/activity/projects/".concat(projectId, "/filter"), params, config);
            case 3:
              res = _context2.sent;
              _ref = res.data || {}, next_anchor = _ref.next_anchor, rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
              return _context2.abrupt("return", (0, _extends5["default"])({}, rest, {
                nextAnchor: next_anchor
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getFileActivities(_x4, _x5, _x6) {
        return _getFileActivities.apply(this, arguments);
      }
      return getFileActivities;
    }()
    /**
     * Export filtered activities by time, users and verbs
     * https://platform.stoplight.autodesk.com/docs/docs-v1/d4ebe73a2542e-export-filtered-activities-as-a-csv-file
     * @param projectId -  the project id
     * @param payload - the request body for file activities csv, shape of
     *                            entity_urn: string,
     *                            force_email: boolean,
     *                            timezone: 'Asia/Shanghai',
     *                            users: array,
     *                            verbs: array,
     *                            from: 'YYYY-MM-DD',
     *                            to: 'YYYY-MM-DD'
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with file activities csv
     */
    )
  }, {
    key: "exportFileActivities",
    value: (function () {
      var _exportFileActivities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, payload, config) {
        var params, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = (0, _extends5["default"])({
                timezone: _utils.DateUtil.getTimezone()
              }, payload);
              _context3.next = 3;
              return this.HttpService.dmV1.post("/activity/projects/".concat(projectId, "/filter/export"), params, config);
            case 3:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function exportFileActivities(_x7, _x8, _x9) {
        return _exportFileActivities.apply(this, arguments);
      }
      return exportFileActivities;
    }()
    /**
     * Save activity info.
     * https://platform.stoplight.autodesk.com/docs/docs-v1/d3051e8a48796-create-activity
     *
     * @param projectId -  the project id
     * @param payload - the activity details with `type` field
     * @param config - Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "recordActivityLog",
    value: (function () {
      var _recordActivityLog = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, payload, config) {
        var res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.HttpService.dmV1.post("/projects/".concat(projectId, "/activities"), payload, config);
            case 2:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function recordActivityLog(_x10, _x11, _x12) {
        return _recordActivityLog.apply(this, arguments);
      }
      return recordActivityLog;
    }()
    /**
     * Save view document activity log.
     * https://platform.stoplight.autodesk.com/docs/docs-v1/195b6d92f30b5-view-document-activity
     *
     * @param projectId -  the project id
     * @param folderUrn -  the folder urn
     * @param documentUrn - the document urn
     * @param payload - the request payload
     * @param config - Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "recordViewDocumentActivityLog",
    value: (function () {
      var _recordViewDocumentActivityLog = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, folderUrn, documentUrn, payload, config) {
        var res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.HttpService.dmV1.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/documents/").concat(_utils.CommonUtil.encodeUrn(documentUrn), "/view_document"), payload, config);
            case 2:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function recordViewDocumentActivityLog(_x13, _x14, _x15, _x16, _x17) {
        return _recordViewDocumentActivityLog.apply(this, arguments);
      }
      return recordViewDocumentActivityLog;
    }()
    /**
     * Record sheet activity log.
     *
     * @param projectId -  the project id
     * @param payload - custom attribute value info with the shape of
     *                   type: A predefined string of activity type, such as 'VIEW_SHEET'
     *                   data: list of object with the shape of `id`
     *                   collection: optional, will make passed activities under same collection
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "recordSheetActivityLog",
    value: (function () {
      var _recordSheetActivityLog = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, payload, config) {
        var res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/activities/sheets:batch-create"), payload, config);
            case 2:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function recordSheetActivityLog(_x18, _x19, _x20) {
        return _recordSheetActivityLog.apply(this, arguments);
      }
      return recordSheetActivityLog;
    }()
    /**
     * Get file activities download info
     *
     * @param param - the query parameter object. With the shape of
     *                         token: "the signed token provided by API to validate user permission"
     * @param conf - Configurable object to overwrite request parameters.
     * @returns a promise that can resolve to download info. With the shape of
     *                         location: 'request_download_url'
     */
    )
  }, {
    key: "getDownloadInfo",
    value: (function () {
      var _getDownloadInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(param, conf) {
        var _this2 = this;
        var config, query, res;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              config = (0, _extends5["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.downloadLinkCancelToken;
                },
                setter: function setter(token) {
                  return _this2.downloadLinkCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.downloadLinkCancelToken = undefined;
                }
              }), conf);
              query = _qs["default"].stringify(param, {
                addQueryPrefix: true
              });
              _context7.next = 4;
              return this.HttpService.dmV1.get("/activities/download".concat(query), config);
            case 4:
              res = _context7.sent;
              return _context7.abrupt("return", res.data);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getDownloadInfo(_x21, _x22) {
        return _getDownloadInfo.apply(this, arguments);
      }
      return getDownloadInfo;
    }()
    /**
     * Get sheet activity available groups
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/b65f2db217c8f-get-sheet-activity-groups
     *
     * @param projectId -  the project id
     * @param id -  the sheet history id
     * @param payload - shape of `timezone`
     * @param config - Configurable object to overwrite request parameters
     * @returns return the available groups array, e.g., ['activity.today', 'activity.lastThreeMonth']
     */
    )
  }, {
    key: "getSheetAvailableGroups",
    value: (function () {
      var _getSheetAvailableGroups = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(projectId, id, payload, config) {
        var _this3 = this;
        var conf, query, res;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              conf = (0, _extends5["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.getSheetGroupsToken;
                },
                setter: function setter(token) {
                  return _this3.getSheetGroupsToken = token;
                },
                clearer: function clearer() {
                  return _this3.getSheetGroupsToken = undefined;
                }
              }), config);
              query = _qs["default"].stringify((0, _extends5["default"])({
                timezone: _utils.DateUtil.getTimezone()
              }, payload), {
                addQueryPrefix: true
              });
              _context8.next = 4;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/activities/sheet-histories/").concat(id, "/groups").concat(query), conf);
            case 4:
              res = _context8.sent;
              return _context8.abrupt("return", Array.isArray(res.data) ? res.data : []);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getSheetAvailableGroups(_x23, _x24, _x25, _x26) {
        return _getSheetAvailableGroups.apply(this, arguments);
      }
      return getSheetAvailableGroups;
    }()
    /**
     * Get single sheet activities
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/ee82e252f4887-get-sheet-activities
     *
     * @param projectId - , the project Id
     * @param payload -, the request body for sheet activities with the shape of
     *                        id: 'sheetHistoryId',
     *                        timezone: 'Asia/Shanghai',
     *                        from: 'YYYY-MM-DD',
     *                        to: 'YYYY-MM-DD',
     *                        priorTo: string,
     *                        nextAnchor: string,
     *                        limit: 100, // by default
     *                        users: string[],
     *                        verbs: string[],
     *                        versionSets: string[]
     * @param config -  Configurable object to overwrite request parameters
     * @returns a promise with activities and nextAnchor, with the shape of
     *                        activities: [actor: object, generator: string, published: string, verb: string, object: object],
     *                        nextAnchor: string
     */
    )
  }, {
    key: "getSheetActivities",
    value: (function () {
      var _getSheetActivities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(projectId, payload, config) {
        var params, res;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              params = (0, _extends5["default"])({
                timezone: _utils.DateUtil.getTimezone()
              }, payload);
              _context9.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/activities/sheets:query"), params, config);
            case 3:
              res = _context9.sent;
              return _context9.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getSheetActivities(_x27, _x28, _x29) {
        return _getSheetActivities.apply(this, arguments);
      }
      return getSheetActivities;
    }()
    /**
     * Export sheet activities
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/2cf6fbbd2ee41-export-sheet-activities
     *
     * @param projectId - , the project Id
     * @param payload -, the request body for sheet activities with the shape of
     *                        id: 'sheetHistoryId',
     *                        timezone: 'Asia/Shanghai',
     *                        from: 'YYYY-MM-DD',
     *                        to: 'YYYY-MM-DD',
     *                        users: string[],
     *                        verbs: string[],
     *                        versionSets: string[]
     *                        sendByEmail: boolean,
     *                        locale: string
     * @param config -  Configurable object to overwrite request parameters
     * @returns a promise with status and signedUrl, with the shape of [status: 'completed|sendEmail', signedUrl: string]
     */
    )
  }, {
    key: "exportSheetActivities",
    value: (function () {
      var _exportSheetActivities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(projectId, payload, config) {
        var params, res;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              params = (0, _extends5["default"])({
                timezone: _utils.DateUtil.getTimezone()
              }, payload);
              _context10.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/activities/sheets:export"), params, config);
            case 3:
              res = _context10.sent;
              return _context10.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function exportSheetActivities(_x30, _x31, _x32) {
        return _exportSheetActivities.apply(this, arguments);
      }
      return exportSheetActivities;
    }()
    /**
     * Get signed url of the exported file
     * @param projectId - , the project id
     * @param payload -, with the presigned token from export command, shape of `token`
     * @param config -  Configurable object to overwrite request parameters
     * @returns a promise with signedUrl, shape of `signedUrl`
     */
    )
  }, {
    key: "getSheetActivitySignedUrl",
    value: (function () {
      var _getSheetActivitySignedUrl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(projectId, payload, config) {
        var res;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/activities/sheets:download"), payload, config);
            case 2:
              res = _context11.sent;
              return _context11.abrupt("return", res.data || {});
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getSheetActivitySignedUrl(_x33, _x34, _x35) {
        return _getSheetActivitySignedUrl.apply(this, arguments);
      }
      return getSheetActivitySignedUrl;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Activities';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Activity;